module.exports = new __parcel__URL__("value.9806a076.svg").toString();